import routes from './routes'
import * as components from './components'
import * as actions from './actions'
import * as types from './actionTypes'
import * as containers from './containers'
import * as links from './links'
import * as reducers from './reducers'

export default {
  actions,
  types,
  reducers,
  containers,
  components,
  links,
  routes
}



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/index.js